"use client";

import { useEffect } from "react";

export function QrCodeScrollHandler() {
  useEffect(() => {
    const onScroll = () => {
      if (
        window.innerHeight + window.scrollY >
        document.body.clientHeight - 686
      ) {
        document.body.classList.remove("qrCodeDisplay");
      } else if (window.scrollY > 300) {
        document.body.classList.add("qrCodeDisplay");
      } else {
        document.body.classList.remove("qrCodeDisplay");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return null;
}
